export default function HeroSection() {
  return (
    <section className="relative h-[70vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1f15980ce87e8b07156611280389064b.jpg"
          alt="Masjid al-Haram"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center text-white">
        <p className="text-[#C9A961] text-xl mb-4 italic" style={{ fontFamily: 'Playfair Display, serif' }}>
          /Sacred Journeys
        </p>
        <h1 className="text-6xl lg:text-7xl font-bold mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
          Umrah & Hajj Packages
        </h1>
        <p className="text-xl lg:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: 'Lora, serif' }}>
          Embark on your spiritual journey with carefully curated packages designed for comfort, devotion, and peace of mind
        </p>
        <button 
          onClick={() => document.querySelector('#packages')?.scrollIntoView({ behavior: 'smooth' })}
          className="px-10 py-4 bg-[#C9A961] text-white rounded-lg text-lg font-semibold hover:bg-[#B89951] transition-all whitespace-nowrap cursor-pointer shadow-lg"
        >
          Explore Packages
        </button>
      </div>
    </section>
  );
}
